import { formatDistanceToNow } from "date-fns";
// import all possible dates and put cache them, then choose if required
import { hr } from "date-fns/locale";
import React from "react";
import { Link } from "react-router-dom";
import { cleanJoin } from "../../utils/stringUtil";
import "./Notification.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faEnvelopeOpen } from "@fortawesome/free-regular-svg-icons";
import Box from "../box/Box";

function Notification({ title, subject, date, status, linkLabel, linkValue, linkTab }) {
  return (
    <Box
      className={cleanJoin(
        "mb-2",
        "notification",
        "has-background-white",
        "p-3",
        status === 0 ? "notification-unread" : "notification-read"
      )}
    >
      <div className="title is-size-5  has-text-left">
        {title}
        <div className="is-pulled-right">
          <FontAwesomeIcon
            icon={status === 0 ? faEnvelope : faEnvelopeOpen}
            className="is-clickable"
          />
        </div>
      </div>
      <div className="subtitle is-size-6">{subject}</div>
      <div className="has-text-left">
        <Link
          to={{ pathname: linkValue, state: { tab: linkTab } }}
          className="has-text-grey-dark no-text-decoration"
        >
          <button className="button">{linkLabel}</button>
        </Link>
        <div className="is-pulled-right mt-2">
          {formatDistanceToNow(new Date(date), { locale: hr })}
        </div>
      </div>
    </Box>
  );
}

export default Notification;
